import { ICategoriaDistanciaCreate } from "interfaces/categoriaDistancia";
import api from "./api";
import {
  IEditCategoria,
  IEditDistancia,
  ICreateTypePayEvento,
  IEventoResponse,
} from "interfaces/eventos";
import { IDisponibilidadeVagas } from "interfaces/disponibilidadeVagas";

function ensureEventoSuccess(response: any, expectedStatus: number) {
  if (response.status === expectedStatus) return response;

  const message =
    response.data?.message ||
    response.data?.error ||
    "Não foi possível salvar os dados do evento.";
  const error: Error & { response?: any } = new Error(message);
  error.response = response;
  throw error;
}

// Cadastrar um novo evento
export async function saveEventos(formData: FormData) {
  const response = await api.post("/evento", formData);
  const validResponse = ensureEventoSuccess(response, 201);
  return { status: validResponse.status, data: validResponse.data };
}

// Atualiar o evento
export async function editEventos(formData: FormData, eventoId: number) {
  try {
    const response = await api.put(`/evento/${eventoId}`, formData);
    const validResponse = ensureEventoSuccess(response, 200);
    return { status: validResponse.status, data: validResponse.data };
  } catch (error: any) {
    throw error;
  }
}

// Excluir o evento
export async function deleteEvento(eventoId: number) {
  try {
    const { data, status } = await api.delete(`/evento/${eventoId}`);
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message);
  }
}

// Excluir documento do evento
type fieldUpdadeType =
  | "urlBanner"
  | "urlImageDestaque"
  | "urlRegulamento"
  | "urlResumo"
  | "urlTermoResp"
  | "urlListaInscrito";

export async function deleteDocumentoEvento(
  eventoId: number,
  field: fieldUpdadeType,
  filename: string
) {
  try {
    const response = await api.delete(`/evento/docs/${eventoId}`, {
      data: { field, filename },
    });
    const validResponse = ensureEventoSuccess(response, 200);
    return { data: validResponse.data, status: validResponse.status };
  } catch (error) {
    throw error;
  }
}

// Publicar evento no SITE
export async function publicarEventoSite(eventoId: number) {
  try {
    const { status } = await api.patch(`/eventos/publicar/${eventoId}`);
    return status === 200 ? true : false;
  } catch (error) {
    throw new Error("Falha na comuniação");
  }
}

// Buscar evento pelo slug
export async function getEventosBySlug(slug: string) {
  const response = await api.get(`/evento/${slug}`);
  return response.data;
}

type optionListEvento = "all" | "active";

export type EventosProps = {
  eventos: IEventoResponse[];
  total: number;
  currentPage: number;
  totalPages: number;
};

export async function getAllEventos(
  page: number = 1,
  limit: number = 10,
  all: optionListEvento = "active"
): Promise<EventosProps> {
  try {
    const resp = await api.get(
      all === "all"
        ? `/evento/all?page=${page}&limit=${limit}`
        : `/evento?page=${page}&limit=${limit}`
    );
    return resp.data;
  } catch (error) {
    throw new Error("Falha na comunicação");
  }
}

export async function getSeachFilterEventos(
  page: number = 1,
  limit: number = 10,
  search: string
): Promise<EventosProps> {
  try {
    const resp = await api.get(
      `/evento/searchfilter?page=${page}&limit=${limit}&search=${search}`
    );
    return resp.data;
  } catch (error: any) {
    throw new Error(error?.message || "Falha na comunicação");
  }
}

export async function getAllEventosPeridoByActive(
  page: number = 1,
  limit: number = 10
): Promise<EventosProps> {
  try {
    const resp = await api.get(
      `/evento/periodo-active?page=${page}&limit=${limit}`
    );
    return resp.data;
  } catch (error) {
    throw new Error("Falha na comunicação");
  }
}

export const EVENTO_STATUS_PROCESSAMENTO = 5;

export type EventosAdminResumo = {
  emProcessamento: number;
};

export async function getEventosEmProcessamentoResumo(): Promise<EventosAdminResumo> {
  try {
    const resp = await api.get("/evento/admin/resumo");
    return resp.data;
  } catch (error) {
    throw new Error("Falha na comunicação");
  }
}

export async function getEventosByStatus(
  page: number = 1,
  limit: number = 10,
  statusId: number = EVENTO_STATUS_PROCESSAMENTO
): Promise<EventosProps> {
  try {
    const resp = await api.get(
      `/evento/all?page=${page}&limit=${limit}&statusId=${statusId}`
    );
    return resp.data;
  } catch (error) {
    throw new Error("Falha na comunicação");
  }
}

export async function getTypeSystem() {
  try {
    const resp = await api.get("/types");
    return resp;
  } catch (error) {
    throw new Error("Falha na comunicação");
  }
}

export async function createCategoriaDistancia(
  data: ICategoriaDistanciaCreate
) {
  try {
    const resp = await api.post("/distancia", data);
    return resp.data;
  } catch (error) {
    throw new Error("Falha na comunicação");
  }
}

export async function deleteCategoriaDistancia(distId: number) {
  try {
    const { data, status } = await api.delete(`/distancia/${distId}`);
    return { data, status };
  } catch (error) {
    throw new Error("Falha na comunicação");
  }
}

export async function editDistancia(data: IEditDistancia) {
  try {
    const resp = await api.put("/distancia", data);
    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error("Falha na comunicação");
  }
}

export async function deleteCategoria(id: number) {
  try {
    const { data, status } = await api.delete(`/categoria/${id}`);
    if (status !== 200) throw new Error(data.message);

    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

export async function updateCategoria(data: IEditCategoria) {
  try {
    const resp = await api.put("/categoria", data);
    return resp.data;
  } catch (error) {
    throw new Error("Falha na comunicação");
  }
}

export async function createCategoria(
  data: IEditCategoria,
  distanciaId: number
) {
  try {
    const resp = await api.post("/categoria", { ...data, distanciaId });
    return resp.data;
  } catch (error) {
    throw new Error("Falha na comunicação");
  }
}

export async function deleteTypePayEvento(id: number) {
  try {
    const { data, status } = await api.delete(`/evento/payment/${id}`);
    return { data, status };
  } catch (error) {
    throw new Error("Falha na comunicação");
  }
}

export async function createTypePayEvento(data: ICreateTypePayEvento) {
  try {
    const resp = await api.post(`/evento/payment`, data);
    return resp.data;
  } catch (error) {
    throw new Error("Falha na comunicação");
  }
}

export async function checkDisponibilidadeInscricao(
  eventoId: number,
  distanciaId: number
): Promise<IDisponibilidadeVagas> {
  const data = {
    eventoId,
    distanciaId,
  };
  try {
    const resp = await api.post(
      "/inscricao/check-disponibilidade-inscricao",
      data
    );
    return resp.data;
  } catch (error) {
    throw new Error("Falha na comunicals");
  }
}
